const jobAPI = {
  methods: {
    update(...rest) {
      return this.$_post(this.$API.jobUpdate, ...rest);
    },
    delete(...rest) {
      return this.$_post(this.$API.jobDelete, ...rest);
    },
    save(...rest) {
      return this.$_post(this.$API.jobSave, ...rest);
    },
    get(...rest) {
      return this.$_post(this.$API.jobFind, ...rest);
    },
    stopAll(...rest) {
      return this.$_post(this.$API.jobStopAll, ...rest);
    },
    startAll(...rest) {
      return this.$_post(this.$API.jobStartAll, ...rest);
    },
    stop(...rest) {
      return this.$_post(this.$API.jobStop, ...rest);
    },
    start(...rest) {
      return this.$_post(this.$API.jobStart, ...rest);
    },
  },
};
export default jobAPI;
